module.exports = __webpack_public_path__ + "static/media/AwaLogo.6e03eb09.png";